import { render } from "./CheckAbilities.vue?vue&type=template&id=164e3350&scoped=true"
import script from "./CheckAbilities.vue?vue&type=script&lang=js"
export * from "./CheckAbilities.vue?vue&type=script&lang=js"

import "./CheckAbilities.vue?vue&type=style&index=0&id=164e3350&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164e3350"]])

export default __exports__